(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rivonova-feature-explorer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rivonova-feature-explorer')) {
    class RivonovaFeatureExplorer extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.cards = Array.from(this.querySelectorAll('[data-card]'));
        this.views = Array.from(this.querySelectorAll('.rfx__view'));
        this.controls = Array.from(this.querySelectorAll('[data-feature]'));
        this.stage = this.querySelector('.rfx__stage');
        this.details = this.querySelector('.rfx__details');
        this.status = this.querySelector('.rfx__status');
        this.mobile = matchMedia('(max-width: 749px)');
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.activeIndex = 0;
        this.setAttribute('data-enhanced', '');
        this.addEventListener('click', (event) => {
          const feature = event.target.closest('[data-feature]');
          const viewButton = event.target.closest('[data-view-step]');
          if (feature && this.contains(feature)) this.activate(Number(feature.dataset.feature), true);
          if (viewButton && this.contains(viewButton)) this.stepView(Number(viewButton.dataset.viewStep));
        }, options);
        this.querySelector('.rfx__numbers').addEventListener('keydown', (event) => {
          const steps = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 };
          let index;
          if (event.key in steps) index = (this.activeIndex + steps[event.key] + this.cards.length) % this.cards.length;
          if (event.key === 'Home') index = 0;
          if (event.key === 'End') index = this.cards.length - 1;
          if (index !== undefined) {
            event.preventDefault();
            this.activate(index, true);
            this.querySelector('.rfx__number[data-feature="' + index + '"]').focus();
          }
        }, options);
        this.stage.addEventListener('keydown', (event) => {
          if (event.target !== this.stage) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.stepView(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, options);
        this.stage.addEventListener('pointerdown', (event) => {
          if (event.isPrimary === false || event.button !== 0 || event.target.closest('button')) return;
          this.dragStart = { x: event.clientX, y: event.clientY, id: event.pointerId };
          this.stage.classList.add('is-dragging');
          this.stage.setPointerCapture(event.pointerId);
        }, options);
        this.stage.addEventListener('pointerup', (event) => {
          if (!this.dragStart || this.dragStart.id !== event.pointerId) return;
          const dx = event.clientX - this.dragStart.x;
          const dy = event.clientY - this.dragStart.y;
          if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.3) this.stepView(dx < 0 ? 1 : -1);
          this.endDrag();
        }, options);
        this.stage.addEventListener('pointercancel', () => this.endDrag(), options);
        this.stage.addEventListener('lostpointercapture', () => this.endDrag(), options);
        this.details.addEventListener('scroll', () => {
          if (this.mobile.matches) return;
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => {
            if (performance.now() < (this.scrollLockUntil || 0)) return;
            if (this.details.scrollTop + this.details.clientHeight >= this.details.scrollHeight - 4) {
              this.activate(this.cards.length - 1, false);
              return;
            }
            const top = this.details.getBoundingClientRect().top + 90;
            let nearest = 0;
            let distance = Infinity;
            this.cards.forEach((card, index) => {
              const delta = Math.abs(card.getBoundingClientRect().top - top);
              if (delta < distance) { distance = delta; nearest = index; }
            });
            this.activate(nearest, false);
          });
        }, options);
        document.addEventListener('shopify:block:select', (event) => {
          const index = this.cards.findIndex((card) => card.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.activate(index, true);
        }, options);
        this.activate(0, false);
      }
      endDrag() { this.dragStart = null; this.stage.classList.remove('is-dragging'); }
      stepView(step) {
        const current = this.views.findIndex((view) => !view.hidden);
        const next = this.views[(current + step + this.views.length) % this.views.length];
        if (next) this.activate(Number(next.dataset.firstFeature), true);
      }
      activate(index, scroll) {
        if (!this.cards[index]) return;
        this.activeIndex = index;
        this.controls.forEach((control) => {
          const active = Number(control.dataset.feature) === index;
          control.classList.toggle('is-active', active);
          control.setAttribute('aria-pressed', String(active));
        });
        this.cards.forEach((card, i) => card.classList.toggle('is-active', i === index));
        const marker = this.querySelector('.rfx__hotspot[data-feature="' + index + '"]');
        this.views.forEach((view) => { view.hidden = view.dataset.viewKey !== marker.dataset.viewKey; });
        this.querySelectorAll('.rfx__hotspot').forEach((hotspot) => { hotspot.hidden = hotspot.dataset.viewKey !== marker.dataset.viewKey; });
        this.status.textContent = this.cards[index].querySelector('.rfx__feature-name').textContent;
        if (scroll && !this.mobile.matches) {
          this.scrollLockUntil = performance.now() + 700;
          const top = this.cards[index].getBoundingClientRect().top - this.details.getBoundingClientRect().top + this.details.scrollTop - 16;
          this.details.scrollTo({ top: Math.max(0, top), behavior: this.reducedMotion.matches ? 'instant' : 'smooth' });
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        cancelAnimationFrame(this.scrollFrame);
      }
    }
    customElements.define('rivonova-feature-explorer', RivonovaFeatureExplorer);
  }

  } catch(e) { console.error(e); }
})();
})();
